import { useAuthStore } from '@/auth/useAuthStore'
import { type AllBrandLocation, type CoreLocation } from '@/core/store/types'
import { OlympusClient } from '@/OlympusClient'

import { useCoreStore } from '../useCoreStore'

/**
 * Fetches "core" data and persists to pinia store
 * @param brandId id of the brand to fetch
 */
export const loadBrand = async (brandId: string): Promise<void> => {
  const coreStore = useCoreStore()
  const authStore = useAuthStore()

  const { brand, locations, theme, session, allBrandLocations } =
    await OlympusClient.dashboard.v3.brands.brand.core({
      headers: {
        'X-Active-Brand-ID': brandId,
      },
      params: {
        brandId,
      },
    })

  coreStore.setActiveBrand({
    ...brand,
    locations: locations as CoreLocation[],
    theme,
  })

  coreStore.setAllBrandLocations(allBrandLocations as AllBrandLocation[])

  if (session) {
    authStore.setBrandSession(session)
    await authStore.reinitializeAuthorizer('loadBrand')
  }
}
